module.exports = __webpack_public_path__ + "img/Icons_Checklist.95217b96.svg";